import React from "react";
import "./ScrollWords.css";

// Renders each word in its own span so GSAP can scrub them one by one.
export default function ScrollWords({ lines }) {
  return lines.map((line, i) => (
    <React.Fragment key={i}>
      {i > 0 && <br />}
      {line.split(" ").map((word, j) => (
        <React.Fragment key={j}>
          <span className="sw">{word}</span>{" "}
        </React.Fragment>
      ))}
    </React.Fragment>
  ));
}
